export enum CART_ACTIONS {
  SET_SELECTION = 'SET_SELECTION'
}
